<template>
  <header class="flex-none relative z-50 text-sm leading-6 font-medium ring-1 ring-gray-900 ring-opacity-5 shadow-sm py-5 bg-white">
    <nav  class="max-w-container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="bg-white">
        <h1 class="font-extrabold text-5xl">TailwindCSS HTML cleaner</h1>
        <p class="text-md ml-2 mt-2 text-gray-500 pb-3 border-b  border-gray-500\30">Sometimes you just need to wipe your html clean. Maybe it's a re-theme, <u>or</u> converting <strong>to</strong> tailwind from some other framework.</p>
        <h2 class="text-lg ml-2 mt-4 text-gray-700">Strip class names from markup 👇</h2>
      </div>
    </nav>
  </header>
  <div class="max-w-8xl mx-auto sm:px-6 lg:px-8 font-sans mt-6">
    <Home/>
    <footer>
      <div class="mt-5">
        <a href="https://www.sitefinitysteve.com" class="mb-3 mr-5 text-indigo-400 underline" target="_blank">Made with ❤️ by sitefinitysteve</a>
        <a href="https://github.com/sitefinitysteve" class="text-indigo-400 underline" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" class="inline" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg> Github</a>
      </div>
      <div class="mt-3 text-gray-400 text-sm">
        No affiliation with tailwindcss the company
      </div>
    </footer>
  </div>  
</template>

<script>
import Home from './components/Home.vue'

export default {
  name: 'App',
  components: {
    Home
  }
}
</script>

<style>

</style>
